var _style, _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBenefits2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "62px",
    height: "75px",
    viewBox: "0 0 62 75",
    style: {
      enableBackground: "new 0 0 62 75"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_2_); fill: #fff;}\r\n")), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 0.2,
    y: -0.1,
    width: 61.6,
    height: 75.1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M17.2,31.1c0.2,0,0.4-0.1,0.5-0.2c0.5,3.2,1.9,7.1,5.3,9.9c0,0,7.8,6.2,15.9-0.1c3.3-2.8,4.7-6.6,5.2-9.8 c0.2,0.2,0.4,0.3,0.6,0.3c0.7,0,1.7-1,2.8-5.1c1.3-5.1,0.1-6.1-1.1-6.1c-0.2,0-0.3,0-0.5,0.1c0,0,0-0.1,0-0.1 c3.4-14.1-3.6-14.6-4.8-14.6c-0.1,0-0.1,0-0.1,0c-0.6-2.6-4-5.4-7.5-5.5c-0.5,0-1,0-1.5,0.1c-1.3,0.3-2.9,0.3-4.6,0.3 c-3.7,0-7.7-0.5-7.7-0.5c-0.1,1.8,1.4,3,1.4,3c-8.5,5.2-5,17-5,17l0,0.1C15.9,20,15.8,20,15.6,20c-1.2,0-2.4,1-1.1,6.1 C15.5,30,16.5,31.1,17.2,31.1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M55.9,49.9c-7.7-2-14-6.4-14-6.4L37,59l-0.9,2.9l0,0l-0.8,2.5L32.7,57c6.5-9.1-1.7-8.7-1.7-8.7 s-8.3-0.4-1.7,8.7l-2.6,7.4l-0.8-2.5l-5.8-18.4c0,0-6.3,4.4-14,6.4C0.3,51.3,0,58,0.3,61.3l0,0c0,0-0.1,4.6,0.7,6.4 c0,0,11.2,7.3,30.1,7.3l0-0.4l0,0.4c18.8,0,30.1-7.3,30.1-7.3c0.7-1.9,0.7-6.4,0.7-6.4C62,58,61.7,51.3,55.9,49.9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBenefits2);
export default __webpack_public_path__ + "static/media/Benefits2.1037b93748bd4837b9e83c88bd700fbb.svg";
export { ForwardRef as ReactComponent };